import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../utilities/props.js";
import View from "../View/index.js";
import s from "./Skeleton.module.css";
const Skeleton = (props) => {
    const { borderRadius = "small", width, height, className, attributes } = props;
    const rootClassNames = classNames(s.root, className);
    return (_jsx(View, { backgroundColor: "disabled", width: width, height: height, borderRadius: borderRadius, className: rootClassNames, attributes: attributes }));
};
Skeleton.displayName = "Skeleton";
export default Skeleton;
